module.exports = __webpack_public_path__ + "img/flag_rect_177.7d007567.png";